import angular from 'angular';
import gettext from 'angular-gettext';

export default angular.module('cms.title.page', [gettext])
    .directive('cmsPageTitle', function ($transitions, gettextCatalog) {
        /** @ngInclude() */
        return {
            link: function (scope, element) {

                const TITLE = element.text;

                $transitions.onSuccess({}, function(transition) {
                    let title = transition.to() ? transition.to().title : TITLE;
                    element.text(gettextCatalog.getString(title));
                });
            }
        }
    }).name;


// WEBPACK FOOTER //
// ./src/cmsCore/PageTitle/TitlePageDirective.js